<template>
  <div class="color-project-card">
    <div class="top-img">
      <img :src="locked ? 'image/color/img_locked.png' : getColor(currentValue.background_color || 'blue')" alt="">
      <div class="text" v-if="!locked">{{currentValue.background_text}}</div>
      <Dropdown class="dropdown" @click.native.stop @change="valueChange" :dataset="currentValue" v-if="!disabled && !locked" @visible-change="visibleChange">
        <template>
          <el-tooltip class="edit" :class="{'show': show}" effect="dark" content="编辑背景" placement="bottom" :disabled="show" v-tooltip-hide>
            <i class="icon iconfont iconicon_input"></i>
          </el-tooltip>
        </template>
      </Dropdown>
    </div>
    <div class="btn">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import Dropdown from './dropdown'
export default {
  components: {
    Dropdown
  },
  props: {
    dataset: {
      type: Object,
      default: () => {}
    },
    locked: {
      type: Boolean,
      default: false
    },
    defaultText: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isInit: false,
      colorData: {},
      show: false
    }
  },
  computed: {
    currentValue: {
      get() {
        if(this.dataset) {
          let arr = this.dataset
          arr.background_text = this.getText()
          return arr
        } else {
          return {}
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    getText() {
      if(this?.dataset?.background_text) {
        return this?.dataset?.background_text
      } else if(this.defaultText) {
        return this.defaultText.slice(0, 8)
      } else {
        return ''
      }
    },
    valueChange(item) {
      this.$emit('change', {...this.dataset, ...item})
    },
    visibleChange(val) {
      this.show = val
    }
  }
}
</script>
<style lang="scss">
.color-project-card {
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  .btn {
    border: 1px solid rgba(32, 32, 32, 0.08);
    border-top: 0 none;
    height: 40px;
    box-sizing: border-box;
    padding: 0 16px;
  }
  &:hover {
    box-shadow: 0px 4px 16px 0px rgba(32,32,32,0.16);
    .btn {
      border: 1px solid rgba(32,32,32,0.04);
      border-top: 0 none;
    }
    .edit {
      display: flex !important;
    }
  }
  &:active {
    box-shadow: 0px 2px 8px 0px rgba(32,32,32,0.08);
    .btn {
      border: 1px solid rgba(32,32,32,0.04);
      border-top: 0 none;
    }
  }
  .top-img {
    height: 86px;
    position: relative;
    .edit {
      font-size: 14px;
      width: 24px;
      height: 24px;
      border-radius: 4px;
      align-items: center;
      justify-content: center;
      color: rgba(255, 255, 255, 0.8);
      display: none;
      cursor: pointer;
      &:hover {
        background-color: rgba(255, 255, 255, 0.24);
        color: #fff;
      }
      &:active {
        background-color: rgba(255, 255, 255, 0.24);
        color: #fff;
      }
    }
    .dropdown {
      position: absolute;
      left: 8px;
      top: 8px;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .show {
      display: flex !important;
      background-color: rgba(255, 255, 255, 0.24);
      color: #fff;
    }
  }
  .text {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    font-size: 28px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
    width: 100%;
    text-align: center;
  }
}
</style>
